import { useStaticQuery, graphql } from "gatsby";
export const useAvaMetadata = () => {
    const data = useStaticQuery(graphql `
        query {
            site {
                siteMetadata {
                    avaDocsBase
                    avaAssetsUrl
                    avaWidgetUrl
                }
            }
        }
    `);
    return data.site.siteMetadata;
};
